<template>
  <fragment>
    <template v-for="item in menuList">
      <el-submenu :index="item.linkUrl"
                  :key="item.id"
                  v-if="item.children && item.children.length > 0">
        <template slot="title">
          <div>
            <i :class="item.icon"></i>
            <span>{{ item.showName?item.showName:item.name }}</span>
          </div>

        </template>
        <menu-tree :menuList="item.children"></menu-tree>
      </el-submenu>
      <el-menu-item @click="addmenuall(item)"
                    v-else
                    :key="item?.id"
                    :index="item.linkType=='_self'?item.linkUrl:''">
        <i :class="item.icon"></i>
        {{item.target}}
        <router-link v-if="true"
                     :target="item.linkType"
                     :to="item.linkUrl">{{item.showName?item.showName:item.name}}</router-link>
        <span v-else>{{item.showName?item.showName:item.name}}</span>
      </el-menu-item>
    </template>
  </fragment>
</template>

<script>
import store from '@/store'
export default {
  name: 'menu-tree',
  props: ['menuList'],
  data () {
    return {
      flag: false
    }
  },
  created () {
  },
  methods: {
    addmenuall (item) {
      // 从vuex取movemenu最新数据
      if (item.linkType == '_self') {
        let isDable = store.state.movemenu
        for (let i = 0; i < isDable.length; i++) {
          // 如果vuex里的movemenu有当前点击数据则return
          if (isDable[i].showName == item.showName) {
            return
          }
        }
        store.commit('addMenu', item);
      }
    }
  }
}
</script>
<style scoped>
.el-menu .el-menu-item {
  min-width: 200px;
  padding: 0 20px;
}
a {
  display: inline-block;
  width: 100%;
  text-decoration: none; /* 去掉下划线 */
  color: inherit; /* 继承父元素颜色，状态不变 */
}
a:hover {
  color: #409eff; /* 悬停时的颜色 */
}
a:active,
a:focus {
  outline: none; /* 去掉点击时的虚线框 */
  color: #409eff; /* 点击时的颜色 */
}
.is-active {
  background-color: rgb(41, 44, 54) !important;
}
</style>